import { Engine } from 'engine/Engine';
import { Entity } from 'engine/Entity';
import { Facet } from 'engine/facets/Facet';
import { V2 } from 'engine/lib/V2';

interface WaterableProps {
  offset: (operator: Entity) => V2,
  maxDistance: number,
  amountNeeded: () => number,
  water: (amount: number, engine: Engine) => boolean,
  isWaterSource?: boolean,
}

export class Waterable extends Facet<WaterableProps> {
}
